import React from 'react';
import { Image, Row, Col, Container } from "react-bootstrap";
import logo from "../img/header/Frame.png";
import kickinLogo from "../img/header/kickin-Logo.png";
import '../css/header.css'
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index"

const HeaderBar = () => {
    return (
        <Container fluid>
            <header>
                <Row className="no-gutters p-3 mx-0 mx-sm-3 mx-md-5 justify-content-between align-items-center">
                    <Col xs={5} md={4} lg={2}>
                        <a href="https://www.swmc.com/" target="_blank" rel="noopener noreferrer">
                            <Image src={logo} fluid className="swLogo header_image sunwest_logo" />
                        </a>
                    </Col>
                    <Col xs={2} lg={1}>
                        <Image src={kickinLogo} fluid className="Kickin' Cancer Logo" />
                        <UserWayAccessibilityMenu color="white" width={40} height={40} />
                    </Col>
                </Row>
            </header>
        </Container>
    );
}

export default HeaderBar;